import script from "./ShopItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopItem.vue?vue&type=script&lang=ts&setup=true"

import "./ShopItem.vue?vue&type=style&index=0&id=7536f8a8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7536f8a8"]])

export default __exports__